import { Component, ElementRef, EventEmitter, HostBinding, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'section-panel',
  templateUrl: './section-panel.component.html',
  styleUrls: ['./section-panel.component.scss']
})

export class SectionPanelComponent {
  @Input() hintContent?: TemplateRef<any>;

  @HostBinding('attr.borderless')
  @Input() borderless: boolean = false;

  @HostBinding('attr.internal')
  @Input() internal: boolean = false;

  @HostBinding('attr.paddings')
  // available values: 'none', 'small', 'medium' and 'large'
  @Input() paddings: string = 'small';

  @Input() disabled: boolean = false;

  public openModalWithHint: EventEmitter<boolean> = new EventEmitter();

  constructor(private ref: ElementRef) {}

  public get clientHeight(): number {
    return this.ref.nativeElement.clientHeight;
  }

  public openHint() {
    this.openModalWithHint.emit(true);
  }

  public closeHint() {
    this.openModalWithHint.emit(false);
  }
}